import { EMPTY_STRING } from '../../constants/common'

export function getText(text) {
  if (!text) {
    return EMPTY_STRING
  }

  const wordArray = text.split(' ').filter(item => !!item)

  const firstWord = wordArray[0]
  const lastWord = wordArray[wordArray.length - 1]

  const firstSymbol = firstWord[0].toUpperCase()
  const lastSymbol = lastWord[0].toUpperCase()

  if (wordArray.length === 1) {
    return firstSymbol
  }

  return firstSymbol + lastSymbol
}
